import React from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import { ActivateLicense } from './ActivateLicense';
import { CheckLicense } from './CheckLicense';
import './Mitel.css';

export const Mitel: React.FC = props => {
    return <Container fluid="lg" className="mt-3">
        <Row className="header-row">
            <Col>
                <Image src="../images/mitel_logo.png" className="logo-image" />
            </Col>
        </Row>
        <Row>
            <Col md="8">
                <ActivateLicense />
            </Col>
            <Col md="4">
                <CheckLicense />
            </Col>
        </Row>
    </Container>
}